module.exports = __webpack_public_path__ + "static/media/badge_level_5_3.60184939.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_5_3.png
// module id = 517
// module chunks = 0